<template>

  <div class="draw-control map-control">
    <md-button :disabled="disabled" :class="buttonClass" @click="onClick(!buttonState)"><md-icon>{{iconName}}</md-icon></md-button>
  </div>

</template>

<script>

export default {
  name: 'MapControl',
  props: {
    iconName: {
      type: String
    },
    type: {
      type: String,
      default: () => {
        return 'click'
      }
    },
    disabled: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  event: 'change',
  data () {
    return {
      buttonState: false
    }
  },
  computed: {
    buttonClass () {
      let toReturn = 'clickable md-raised'
      if (this.type === 'toggle' && this.buttonState) toReturn += ' md-primary'
      return toReturn
    }
  },
  methods: {
    onClick (state) {
      this.buttonState = state
      switch (this.type) {
        case 'click':
          return this.$emit('click')
        case 'toggle':
          return this.$emit('change', this.buttonState)
      }
    }
  }
}
</script>

<style lang="scss">

</style>
